import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as search } from './search/searchReducer';
import { reducer as property } from './property/propertyReducer';
import { reducer as propertyAvailability } from './propertyAvailability/propertyAvailabilityReducer';
import { reducer as user } from './user/userReducer';
import { reducer as userEnvironment } from './userEnvironment/userEnvironmentReducer';
import { reducer as split } from './split/splitReducer';
import { reducer as siteMessage } from './siteMessage/siteMessageReducer';
import { reducer as campaign } from './campaign/campaignReducer';
import { reducer as ui } from './ui/uiReducer';
import { reducer as quote } from './quote/quoteReducer';
import { reducer as checkout } from './checkout/checkoutReducer';
import { reducer as booking } from './booking/bookingReducer';
import { reducer as error } from './error/errorReducer';
import { reducer as pointsConversion } from './pointsConversion/pointsConversionReducer';
import { reducer as enquiry } from './enquiry/enquiryReducer';
import { reducer as destination } from './destination/destinationReducer';
import { reducer as memberFavourites } from './memberFavourites/memberFavouritesReducer';
import { reducer as promoArea } from './promoArea/promoAreaReducer';
import { reducer as recommendedProperty } from './recommendedProperty/recommendedPropertyReducer';

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    search,
    property,
    propertyAvailability,
    user,
    userEnvironment,
    split,
    siteMessage,
    campaign,
    ui,
    quote,
    checkout,
    booking,
    error,
    pointsConversion,
    enquiry,
    destination,
    memberFavourites,
    promoArea,
    recommendedProperty,
  });

export default createRootReducer;
